/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation202,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLangBotexamlangidFinishTranslation.ts";

export const postApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParamsSchema =
  z.object({
    botExamLangId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamRevisionLangBotexamlangidFinishTranslation202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslation202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamRevisionLangBotexamlangidFinishTranslation400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamRevisionLangBotexamlangidFinishTranslation401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamRevisionLangBotexamlangidFinishTranslation404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamRevisionLangBotexamlangidFinishTranslation500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500>;

export const postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponseSchema =
  z.lazy(
    () => postApiV1ExamRevisionLangBotexamlangidFinishTranslation202Schema,
  ) as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse>;
